import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "../../../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/cart/update/comment");
export function apiUpdateCartComment(comment: string) {
  return fetch(apiUrl, {
    method: "POST",
    body: JSON.stringify({ comment }),
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
}
